import {Component, OnDestroy, OnInit} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ConstsHelper } from '../../../../helpers/consts.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { LineInterface } from '../../models/line.interface';
import { UpdateSelectedProcedure } from '../../../shared/store/actions/selected-procedure.actions';
import { MsisdnNotificationsInterfaceState } from '../../../shared/store/state/msisdn-notifications.state';
import { CustomerMsisdnNotificationPaginatorInterface } from '../../../shared/models/customer-msisdn-notification-paginator.interface';
import { SelectedProcedureInterfaceState } from '../../../shared/store/state/selected-procedure.state';
import { GetLine } from '../../store/actions/line.actions';
import { MsisdnListInterfaceState } from '../../store/state/msisdn-list.state';
import { GetMsisdnList } from '../../store/actions/msidn-list.actions';
import { MsisdnListInterface } from '../../models/msisdn-list.interface';
import { LineInterfaceState } from '../../store/state/line.state';
import { ConsumptionInterfaceState } from '../../store/state/consumption.state';
import { ConsumptionInterface } from '../../models/consumption.interface';
import {
  DeleteMsisdnNotifications,
  GetMsisdnNotifications
} from '../../../shared/store/actions/customer-msisdn-notifications.actions';
import { SupportUserInterface } from '../../../shared/models/support-user.interface';
import { ExtranetService } from '../../../shared/services/extranet.service';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-lines-list',
  templateUrl: './lines-list.component.html',
  styleUrls: ['./lines-list.component.css'],
  standalone: false
})
export class LinesListComponent implements OnInit, OnDestroy {

  consumptionTab: string;
  documentsTab: string;
  lineManagementTab: string;
  notificationsTab: string;
  consumption: ConsumptionInterface = null;
  msisdnList: Array<MsisdnListInterface>;
  selectedMsisdn: string|null = null;
  selectedLine: LineInterface;
  visibility: boolean = false;
  arrowImage: string = 'arrow_down';
  selectedProcedure: string = null;
  notificationsPaginator: CustomerMsisdnNotificationPaginatorInterface;
  line: LineInterface = null;
  faqPageCode: string;
  supportUser: SupportUserInterface;
  procedureInParam: string;
  defaultMsisdn: string|null;
  brand?: string;

  constructor(
      private store: Store<any>,
      private router: Router,
      private activateRoute: ActivatedRoute,
      private location: Location,
      private extranetService: ExtranetService
  ) {}

  listLinesStatus(e: { status: number, msisdn: string|null }) {
    if (e.status === 1) {
      this.arrowImage = 'arrow_down';
      this.visibility = false;
    }
    this.getSelectedLine(e.msisdn);
  }

  ngOnInit() {
    this.store.pipe(select(ConstsHelper.REDUCER_MSISDN_LIST)).subscribe((response: MsisdnListInterfaceState) => {
      if (response.list instanceof Array && response.list.length > 0) {
        this.msisdnList = response.list;
        if (this.defaultMsisdn) {
          const lineIndex = this.msisdnList.findIndex(l => l.phoneNumber === this.defaultMsisdn);
          if (lineIndex !== -1) {
            this.getSelectedLine(this.msisdnList[lineIndex].phoneNumber);
          } else {
            this.getSelectedLine(this.msisdnList[0].phoneNumber);
          }
        } else if (this.selectedMsisdn !== this.msisdnList[0].phoneNumber) {
          this.selectedMsisdn = this.msisdnList[0].phoneNumber;
          this.getSelectedLine(this.msisdnList[0].phoneNumber);
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CONSUMPTION)).subscribe((response: ConsumptionInterfaceState) => {
      if (null !== response.consumption) {
        if (response.consumption.date == null) {
          this.consumption = null;
          if (this.consumptionTab !== '') {
            this.setActiveTab('infos', false, false);
          }
        } else {
          this.consumption = response.consumption;
        }
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_LINE)).subscribe((response: LineInterfaceState) => {
      if (response.line != null) {
        this.selectedLine = response.line;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER_MSISDN_NOTIFICATIONS)).subscribe((response: MsisdnNotificationsInterfaceState) => {
      if (response.result != null) {
        this.notificationsPaginator = response.result;
      }
    });

    this.store.pipe(select(ConstsHelper.REDUCER_SELECTED_PROCEDURE)).subscribe((response: SelectedProcedureInterfaceState) => {
      if (response.code != null) {
        this.selectedProcedure = response.code;
      }
    });

    this.brand = environment.data.brand;
    this.defaultMsisdn = null;
    this.procedureInParam = null;
    if (
        localStorage.getItem(ConstsHelper.LOCAL_STORAGE_PROCEDURE_TO_OPEN) ||
        (
            this.activateRoute.snapshot.queryParams &&
            ['debloquer-ligne', 'terminate-line', 'recharge', 'retractation'].indexOf(this.activateRoute.snapshot.queryParams['procedure']) !== -1
        )
    ) {
      if (this.activateRoute.snapshot.queryParams['msisdn']) {
        this.defaultMsisdn = this.activateRoute.snapshot.queryParams['msisdn'];
      }
      if (this.activateRoute.snapshot.queryParams['option']) {
        localStorage.setItem(ConstsHelper.LOCAL_STORAGE_SELECTED_RECHARGE_OPTION, this.activateRoute.snapshot.queryParams['option']);
      }
      if (this.activateRoute.snapshot.queryParams['procedure']) {
        this.procedureInParam = this.activateRoute.snapshot.queryParams['procedure'];
      } else {
        this.procedureInParam = localStorage.getItem(ConstsHelper.LOCAL_STORAGE_PROCEDURE_TO_OPEN);
      }
      this.setActiveTab('gestion', false, true);
    } else {
      this.setActiveTab(this.activateRoute.snapshot.params['tab'], false, true);
    }
    this.supportUser = this.extranetService.getSupportUser();
    this.msisdnList = [];
    this.selectedLine = null;
    this.selectedProcedure = null;
    this.store.dispatch(new GetMsisdnList());
  }

  setActiveTab(tab: string, refresh: boolean, withParams: boolean) {
    this.consumptionTab = '';
    this.documentsTab = '';
    this.lineManagementTab = '';
    this.notificationsTab = '';
    if (['', 'undefined', undefined].indexOf(tab) !== -1) {
      tab = 'suiviconso';
      this.faqPageCode = 'lines_suiviconso';
    }
    if (refresh) {
      this.store.dispatch(new GetLine(this.selectedLine.phoneNumber));
    }
    switch (tab) {
      case 'suiviconso':
        this.consumptionTab = 'active';
        this.faqPageCode = 'lines_suiviconso';
        break;
      case 'infos':
        this.documentsTab = 'active';
        this.faqPageCode = 'lines_infos';
        break;
      case 'gestion':
        this.lineManagementTab = 'active';
        this.faqPageCode = 'lines_gestion';
        break;
      case 'notifications':
        this.notificationsTab = 'active';
        this.faqPageCode = 'lines_notifications';
        if (
            this.notificationsPaginator &&
            this.notificationsPaginator.totalUnread > 0 &&
            this.notificationsPaginator.data.length > 0 &&
            this.supportUser == null
        ) {
          this.store.dispatch(new DeleteMsisdnNotifications(this.selectedLine.phoneNumber, this.notificationsPaginator.data[0].id));
        }
        break;
    }
    this.store.dispatch(new UpdateSelectedProcedure(''));
    let url = '/lignes/' + tab;
    if (this.procedureInParam && withParams) {
      url += '/' + this.procedureInParam;
    }
    this.location.replaceState(url);
  }

  linesListVisibility() {
    if (this.selectedProcedure == null || this.selectedProcedure === '') {
      this.visibility = !this.visibility;
      if (this.visibility) {
        this.arrowImage = 'arrow_up';
      } else {
        this.arrowImage = 'arrow_down';
      }
    }
  }

  private getSelectedLine(msisdn: string) {
    this.store.dispatch(new GetLine(msisdn));
    const splitRouter = this.router.url.split('/');
    if (splitRouter.indexOf('lignes') !== -1) {
      this.store.dispatch(new GetMsisdnNotifications(msisdn, 1, 5));
    }
    this.visibility = false;
    this.arrowImage = 'arrow_down';
  }

  ngOnDestroy() {
    this.msisdnList = [];
    this.selectedLine = null;
    this.selectedProcedure = null;
    this.defaultMsisdn = null;
  }
}
